import { css } from '@emotion/react';
import type * as React from 'react';

type Props = {
	readonly variant: 'horizontal' | 'vertical';
	readonly height: number;
};

const LOGO_SOURCES: Readonly<Record<Props['variant'], string>> = Object.freeze({
	horizontal: '/icons/adar-provence-logo-horizontal.svg',
	vertical: '/icons/adar-provence-logo-vertical.svg',
});

const imageStyle = css`
	display: block;
	width: auto;
`;

/** Decorative application logo (ADAR Provence), sized by height; the name is carried by an accessible parent. */
const AppLogo: React.FC<Props> = ({ variant, height }) => {
	return <img src={LOGO_SOURCES[variant]} height={height} alt="" aria-hidden="true" css={imageStyle} />;
};

export default AppLogo;
